import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "15 17 20 12 15 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 18v-2a4 4 0 0 1 4-4h12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Forward";
const Forward = memo(themed(Icon));
export {
  Forward
};
//# sourceMappingURL=forward.js.map
